/**
 * Utilitários compartilhados do módulo de Perfil e Configurações.
 * Funções puras de formatação/exibição e opções de selects.
 */

/** Duas primeiras letras do nome, em maiúsculas, para fallback de avatar. */
export function getInitials(name?: string | null): string {
  return (name || '').trim().substring(0, 2).toUpperCase() || '??'
}

/**
 * Resolve a URL do avatar: prefixa URLs relativas com a base da API.
 * Mesmo tratamento usado em Header.vue e no módulo Doctors.
 */
export function resolveAvatarUrl(url?: string | null): string | null {
  if (!url) return null
  const base = process.env.VUE_APP_API_URL
  if (url.startsWith('/') && base) return `${base}${url}`
  return url
}

/** Aplica a máscara de CPF (###.###.###-##) sobre uma string de dígitos. */
export function formatCPF(cpf?: string | null): string {
  if (!cpf) return ''
  const digits = cpf.replace(/\D/g, '').slice(0, 11)
  return digits
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
}

/**
 * Mascara parte do CPF para exibição, preservando privacidade (LGPD).
 * Ex.: 12345678901 -> "***.456.789-**". Se incompleto, cai no formato padrão.
 */
export function maskCPF(cpf?: string | null): string {
  if (!cpf) return ''
  const digits = cpf.replace(/\D/g, '').slice(0, 11)
  if (digits.length !== 11) return formatCPF(cpf)
  return `***.${digits.slice(3, 6)}.${digits.slice(6, 9)}-**`
}

/** Converte uma data ISO (yyyy-mm-dd ou ISO completo) para dd/mm/aaaa. */
export function isoToBrDate(iso?: string | null): string {
  if (!iso) return ''
  const datePart = iso.split('T')[0]
  const [year, month, day] = datePart.split('-')
  if (!year || !month || !day) return ''
  return `${day}/${month}/${year}`
}

/** Converte uma data dd/mm/aaaa para ISO (yyyy-mm-dd). Retorna null se incompleta. */
export function brDateToIso(br?: string | null): string | null {
  if (!br) return null
  const digits = br.replace(/\D/g, '')
  if (digits.length !== 8) return null
  const day = digits.slice(0, 2)
  const month = digits.slice(2, 4)
  const year = digits.slice(4, 8)
  return `${year}-${month}-${day}`
}

/** Formata um telefone de dígitos para (##) #####-####. */
export function formatPhone(phone?: string | null): string {
  if (!phone) return ''
  const digits = phone.replace(/\D/g, '').slice(0, 11)
  if (digits.length <= 10) {
    return digits.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3').replace(/[-\s()]+$/, '')
  }
  return digits.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3').replace(/[-\s()]+$/, '')
}

/** Remove tudo que não é dígito (para enviar ao backend). */
export function onlyDigits(value?: string | null): string {
  return (value || '').replace(/\D/g, '')
}
